import { render, staticRenderFns } from "./CustomValidation.vue?vue&type=template&id=4a71ff79&scoped=true"
import script from "./CustomValidation.vue?vue&type=script&lang=js"
export * from "./CustomValidation.vue?vue&type=script&lang=js"
import style0 from "./CustomValidation.vue?vue&type=style&index=0&id=4a71ff79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71ff79",
  null
  
)

export default component.exports